import { render, staticRenderFns } from "./WriteServe.vue?vue&type=template&id=d2701f8a&"
import script from "./WriteServe.vue?vue&type=script&lang=js&"
export * from "./WriteServe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports